import { Column, Row, Text } from '~/commonComponents';
import { WarningSolidIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';

interface IInfoSectionProps {
  title: string;
  value: string | number | undefined;
  showWarningIcon?: boolean;
}

export const InfoSection = ({ title, value, showWarningIcon = false }: IInfoSectionProps) => (
  <Column gap={4}>
    <Row alignItems="center" gap={8}>
      <Text bold fontSize={20}>
        {title}:
      </Text>
      {showWarningIcon && <WarningSolidIcon color={Colors.warning_500} size={18} />}
    </Row>
    <Text>{value}</Text>
  </Column>
);
